import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=4f359699&scoped=true"
var script = {}
import style0 from "./NoData.vue?vue&type=style&index=0&id=4f359699&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f359699",
  null
  
)

export default component.exports